import {
  PickingJobResolutionDestination,
  PickingJobSegment,
  PickingJobStatus,
} from '@/graphql/generatedTypes';
import { formatDateTimeLocalized } from '@/utils/formatter';
import i18n from '@/utils/i18n';

const STATUS_LABEL_KEYS: Record<PickingJobStatus, string> = {
  [PickingJobStatus.PickingNotStarted]: 'Picking:statusPickingNotStarted',
  [PickingJobStatus.PickingInProgress]: 'Picking:statusPickingInProgress',
  [PickingJobStatus.Picked]: 'Picking:statusPicked',
  [PickingJobStatus.DeliveryInProgress]: 'Picking:statusDeliveryInProgress',
  [PickingJobStatus.DeliveryIncomplete]: 'Picking:statusDeliveryIncomplete',
  [PickingJobStatus.Delivered]: 'Picking:statusDelivered',
  [PickingJobStatus.Released]: 'Picking:statusReleased',
};

export function pickingJobStatusLabel(status: PickingJobStatus): string {
  return i18n.t(STATUS_LABEL_KEYS[status]);
}

export function pickingJobSegmentLabel(segment: PickingJobSegment): string {
  return segment === PickingJobSegment.Event
    ? i18n.t('Picking:segmentEvent')
    : i18n.t('Picking:segmentOpenSystem');
}

export function resolutionDestinationLabel(
  destination: PickingJobResolutionDestination,
): string {
  return destination === PickingJobResolutionDestination.Warehouse
    ? i18n.t('Picking:resolutionDestinationWarehouse')
    : i18n.t('Picking:resolutionDestinationPartner');
}

/** "When · who" for a manual intervention; the name is left off when unknown. */
export function formatByline(
  at: string,
  by: { name?: string | null } | null | undefined,
): string {
  const when = formatDateTimeLocalized(new Date(at), i18n.language);
  return by?.name ? `${when} · ${by.name}` : when;
}
